export enum SpaceRankBoostType {
  ADMIN_BOOST = 'ADMIN_BOOST',
}

export interface SpaceRankBoost {
  id?: string;
  type: SpaceRankBoostType;
  points: number;
  expiresAt: string; 
  visible: boolean;// ISO date string (LocalDate in Java)
}

export interface RemoveSpaceRankBoostRequest {
  boostId: string;
}
